function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { AgentCard } from './agent-card';
import * as styles from './agent-list.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AgentList = _ref => {
  var type = _ref.type,
    _ref$agencies = _ref.agencies,
    agencies = _ref$agencies === void 0 ? [] : _ref$agencies,
    _ref$agents = _ref.agents,
    agents = _ref$agents === void 0 ? [] : _ref$agents,
    _ref$handleDisableSub = _ref.handleDisableSubmit,
    handleDisableSubmit = _ref$handleDisableSub === void 0 ? () => {} : _ref$handleDisableSub,
    _ref$handleFormData = _ref.handleFormData,
    handleFormData = _ref$handleFormData === void 0 ? () => {} : _ref$handleFormData;
  var isAgency = type === 'AGENCY';
  var _useState = useState(isAgency ? agencies.map(agency => ({
      id: Number(agency.agency.agencyId),
      checked: true
    })) : agents.map(agent => ({
      id: Number(agent.agent.agentId),
      checked: true
    }))),
    _useState2 = _slicedToArray(_useState, 2),
    checkboxes = _useState2[0],
    setCheckboxes = _useState2[1];
  var allUnchecked = checkboxes.filter(checkbox => checkbox.checked).length === 0;
  var toggleCheckbox = checkboxIndex => {
    var clone = [...checkboxes];
    setCheckboxes(clone.map((item, index) => index === checkboxIndex ? {
      id: item.id,
      checked: !item.checked
    } : item));
  };
  useEffect(() => {
    handleDisableSubmit(allUnchecked);
  }, [handleDisableSubmit, allUnchecked]);
  useEffect(() => {
    handleFormData({
      type,
      ids: checkboxes.filter(checkbox => checkbox.checked).map(item => item.id)
    });
  }, [handleFormData, type, checkboxes]);
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.cardContainer
  }, isAgency ? agencies.map((agency, index) => ___EmotionJSX(AgentCard, {
    key: agency.agency.agencyId,
    type: type,
    agency: agency.agency,
    checked: checkboxes[index].checked,
    onClick: () => toggleCheckbox(index)
  })) : agents.map((agent, index) => ___EmotionJSX(AgentCard, {
    key: agent.agent.agentId,
    type: type,
    agent: agent.agent,
    checked: checkboxes[index].checked,
    onClick: () => toggleCheckbox(index)
  }))), allUnchecked && ___EmotionJSX("div", {
    css: styles.message
  }, "Please select at least one agen".concat(isAgency ? 'cy' : 't', " to request an appraisal.")));
};